module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"actionPrev":"Precedente","actionNext":"Successivo"},"en":{"actionPrev":"Previous","actionNext":"Next"}}')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/app/surveys/survey.vue
// module id = 118
// module chunks = 0